<template>
  <view class="navBar">
    <view class="status_bar" style="height: var(--status-bar-height); width: 100%;">
    </view>
    <uniNavBar status-bar fixed :title="$props.title" :border="false">
      <template v-slot:left>
        <view class="uni-head-btn" @click="onBack">
          <uni-icons size="24" type="back"></uni-icons>
        </view>
        <view class="uni-head-btn" v-for="item in leftButtonList" :key="item.btnType" @click="onClickNavButton(item)">
          <cartCount v-if="item.btnType === 'cart'" />
          <uni-icons v-else size="32" :type="'icomoon-' + item.iconType"></uni-icons>
        </view>
      </template>
      <template v-slot:right>
        <view class="uni-head-btn" v-for="item in rightButtonList" :key="item.btnType" @click="onClickNavButton(item)">
          <cartCount v-if="item.btnType === 'cart'" />
          <uni-icons v-else size="32" :type="'icomoon-' + item.iconType"></uni-icons>
        </view>
      </template>
    </uniNavBar>
  </view>
</template>

<script>
import uniNavBar from "@/components/uni-nav-bar/uni-nav-bar.vue";
import uniBadge from "@/components/uni-badge/uni-badge.vue";
import cartCount from "@/components/cartCount.vue";
import { navBack } from "@/utils/navBar.js";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    uniNavBar,
    uniBadge,
    cartCount,
  },
  props: {
    title: {
      type: String,
      default: "mall-app",
    },
    buttons: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(["navBar"]),
    leftButtonList() {
      const leftBtnList = this.$props.buttons?.filter(
        (item) => item.float === "left"
      );
      return leftBtnList || [];
    },
    rightButtonList() {
      const rightBtnList = this.$props.buttons
        ?.filter((item) => item.float !== "left")
        ?.reverse();
      return rightBtnList || [];
    },
  },
  methods: {
    onClickNavButton(e) {
      this.$emit("onNavigationBarButtonTap", e);
    },
    onBack() {
      navBack()
    },
  },
};
</script>

<style lang="scss" scoped>
/* .navBar {
  display: none;
  &.show {
    display: block;
  }
} */

.uni-navbar__header-btns-right {
  .uni-head-btn {
    padding-left: 20upx;
  }
}

.uni-navbar__header-btns-left {
  .uni-head-btn {
    padding-right: 20upx;
  }
}

.uni-head-btn {
  margin: 0 4upx;

  .icon-font {
    min-width: 1em;
  }
}
</style>
